import { render, staticRenderFns } from "./TCLAArticleReport.vue?vue&type=template&id=3e5f88f9&scoped=true"
import script from "./TCLAArticleReport.vue?vue&type=script&lang=js"
export * from "./TCLAArticleReport.vue?vue&type=script&lang=js"
import style0 from "./TCLAArticleReport.vue?vue&type=style&index=0&id=3e5f88f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5f88f9",
  null
  
)

export default component.exports